import React from "react";
import "components/BusinessCampaign/MultipleTextTitleComponent.scss";
import { convertHtmlToReact } from "@hedgedoc/html-to-react/dist/convertHtmlToReact";
import useWindowDimensions from "utils/WindowWidth";

const MultipleTextTitleComponent = ({
    title_text,
    descriptions,
}) => {
    return (
      <>
          <div className="resi-container">
              <div className="resi-margin-container">
                  <div className="multiple_text-title-component-container">
                     <div className="title-text" tabIndex="0">
                       {convertHtmlToReact(title_text)}
                     </div>
                      <div className="text-title-descriptions">
                          {descriptions.map((item) => {
                                return (
                                    <div className="text-title-description">
                                    {convertHtmlToReact(item.description)}
                                    </div>
                                )
                          })}
                      </div>
                  </div>
              </div>
          </div>
      </>
    );
};

export default MultipleTextTitleComponent;